import { useEffect } from 'react';
import { useToggle } from '../../../../infra/small-tools/use-toggle';
import { setLastInteractionDate, wasPreviouslyInteracted } from '../../../../infra/persistence/interactionStateUtils';
export var useTwoFaAnnouncementPopup = function (_a) {
    var canUserSeeModal = _a.canUserSeeModal, didUserTakeAction = _a.didUserTakeAction, modalSeenVariableName = _a.modalSeenVariableName;
    var modal = useToggle(false);
    useEffect(function () {
        if (canUserSeeModal && !didUserTakeAction && !wasPreviouslyInteracted(modalSeenVariableName)) {
            modal.setOn();
        }
    }, []);
    var handleClose = function () {
        setLastInteractionDate(modalSeenVariableName);
        modal.setOff();
    };
    return {
        modal: modal,
        handleClose: handleClose,
    };
};
